export const SET_MERCHANDISE_VARIENT = "SET_MERCHANDISE_VARIENT"
export const SET_MERCHANDISE_VARIENT_OBJ = "SET_MERCHANDISE_VARIENT_OBJ"
export const SET_MERCHANDISE_VARIENT_TERM_IMG = "SET_MERCHANDISE_VARIENT_TERM_IMG"
export const SET_MERCHANDISE_VARIENT_IMG = "SET_MERCHANDISE_VARIENT_IMG"
